/* eslint-disable react/jsx-no-bind */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import AddIcon from 'Component/AddIcon';
import Button from 'Component/Button';
import { SIZE_NONE, TYPE_TEXT } from 'Component/Button/Button.config';
import { BLACK_KEY, S_KEY } from 'Component/Icon/Icon.config';
import MinusIcon from 'Component/MinusIcon';
import SkeletonComponent from 'Component/Skeleton/Skeleton.component';
import { EventsType, FieldAttrType } from 'Type/Field.type';
import { DEFAULT_MAX_PRODUCTS } from 'Util/Product/Extract';
import { FIELD_TYPE } from 'Util/Validator/Field.config';

import { FIELD_NUMBER_SKELETON, LARGE_SIZE, SMALL_SIZE } from './FieldNumber.config';

import './FieldNumber.style.scss';
/**
 * Field Number
 * @class FieldNumber
 * @namespace Bodypwa/Component/FieldNumber/Component */
export class FieldNumberComponent extends PureComponent {
    static propTypes = {
        attr: FieldAttrType.isRequired,
        events: EventsType.isRequired,
        setRef: PropTypes.func.isRequired,
        value: PropTypes.number.isRequired,
        handleValueChange: PropTypes.func.isRequired,
        isDisabled: PropTypes.bool.isRequired,
        handleInputChange: PropTypes.func.isRequired,
        handleInputBlur: PropTypes.func.isRequired,
        size: PropTypes.oneOf([SMALL_SIZE, LARGE_SIZE]),
        isReadOnly: PropTypes.bool.isRequired,
        isLoading: PropTypes.bool,
        isErrorMessage: PropTypes.bool,
        className: PropTypes.string,
        errorMessagePosition: PropTypes.string
    };

    static defaultProps = {
        size: LARGE_SIZE,
        isLoading: false,
        isErrorMessage: false,
        className: '',
        errorMessagePosition: ''
    };

    render() {
        const {
            attr,
            attr: { min = 1, max = DEFAULT_MAX_PRODUCTS },
            events,
            setRef,
            value,
            handleValueChange,
            handleInputChange,
            handleInputBlur,
            isDisabled,
            size,
            isReadOnly,
            isLoading,
            isErrorMessage,
            className,
            errorMessagePosition
        } = this.props;

        if (isLoading) {
            return (
                <div>
                    <SkeletonComponent items={ FIELD_NUMBER_SKELETON } />
                </div>
            );
        }

        const isAddDisabled = +value >= max;
        const isSubtractDisabled = value <= min;
        const message = isAddDisabled
            ? __(value === 1 ? 'Only 1 item left' : 'Only %s items left', value)
            : '';
        const errorMesageClass = isErrorMessage && message ? 'mb-6!' : '';

        return (
            <div
                block="FieldNumber"
                elem="Number"
                className={ `${ errorMesageClass } ${className}` }
                mods={ {
                  size, error: !!message, disabled: isDisabled, readonly: isReadOnly
              } }
            >
                <input
                    ref={ (elem) => setRef(elem) }
                    { ...attr }
                    { ...events }
                    type={ FIELD_TYPE.number }
                    readOnly={ isReadOnly }
                    aria-label={ __('Value') }
                    onChange={ (e) => handleInputChange(e.target.value ? 
                        parseInt(e.target.value, 10) : e.target.value) }
                        
                    onBlur={ (e) => handleInputBlur(e.target.value ? parseInt(e.target.value, 10) : e.target.value) }
                    value={ value }
                    disabled={ isDisabled }
                />
                <Button
                    isDisabled={ isAddDisabled || isDisabled }
                    onClick={ () => handleValueChange(+value + 1) }
                    aria-label={ __('Add') }
                    actionType={ FIELD_TYPE.button }
                    type={ TYPE_TEXT }
                    size={ SIZE_NONE }
                    readOnly={ isReadOnly }
                >
                    <AddIcon block="SubtractButton" isPrimary size={ S_KEY } color={ BLACK_KEY } />
                </Button>
                <Button
                    isDisabled={ isSubtractDisabled || isDisabled }
                    onClick={ () => handleValueChange(+value - 1) }
                    aria-label={ __('Subtract') }
                    actionType={ FIELD_TYPE.button }
                    type={ TYPE_TEXT }
                    size={ SIZE_NONE }
                    readOnly={ isReadOnly }
                >
                    <MinusIcon block="AddButton" isPrimary size={ S_KEY } color={ BLACK_KEY } />
                </Button>
                <div block="FieldNumber" elem="MessageError" className={ errorMessagePosition }>
                    { message && <div block="FieldNumber" elem="Message">{ message }</div> }
                </div>
            </div>
        );
    }
}

export default FieldNumberComponent;
